import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  VerifyInformationComponent
} from "./modules/private/verify-information/verify-information/verify-information.component";
import {AuthGuard} from "./core/auth.guard";
import {NoAuthGuard} from "./core/no-auth.guard";

const routes: Routes = [
  {
    path: '',
    component: VerifyInformationComponent,
  },
  {
    path: '**',
    redirectTo: '/',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
